/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2023-08-16 11:21:56
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-09-20 10:05:02
 */
import request from '../util/request'
// 登录
export function login (data) {
  return request({
    url: '/api/user/login',
    method: 'post',
    data: data,
  })
}

// 注册
export function register (data) {
  return request({
    method: 'post',
    url: '/api/user/register',
    data: data,
  })
}

// 验证token
export function checkToken () {
  return request({
    method: 'post',
    url: '/userInfo/checkToken',
    headers: localStorage.getItem('token') ? {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    } : {
    },
  })
}

// 获取用户信息
export function getUserInfoByUserId () {
  return request({
    url: '/system/userInfo/getUserInfoByUserId',
    method: 'post',
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    },
  })
}

// 获取用户信息
export function updateUserInfo (data) {
  return request({
    url: '/userInfo/updateUserInfo',
    method: 'post',
    data: data,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    },
  })
}

// 修改密码
export function updateUserPwd (data) {
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    },
  })
}

// 获取验证码
export function sendEmail (email) {
  return request({
    method: 'post',
    url: '/api/user/sendEmail',
    data: { email },
  })
}

// 验证码验证
export function checkEmailCode (data) {
  return request({
    method: 'post',
    url: '/api/user/checkEmailCode',
    data: data,
  })
}

// 邮箱更换密码
export function emailUpdatePassword (data) {
  return request({
    method: 'post',
    url: '/api/user/emailUpdatePassword',
    data: data,
  })
}

// 手机号更换密码
export function phoneUpdatePassword (data) {
  return request({
    method: 'post',
    url: '/updatePwdForMobile',
    data: data,
  })
}

// 电话号码找回密码
export function getPhoneCode (phone) {
  return request({
    method: 'post',
    url: '/getPhoneCode',
    data: {
      platForm: '2',
      phone,
    },
  })
}

// 获取手机号码
export function getPhoneById (params) {
  return request({
    method: 'post',
    url: '/index/getPhoneById',
    params,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    }
  })
}